<template>
    <filters-wrapper :has-active-filters="props.hasActiveFilters" @submit="emit('submit')" @reset="emit('reset')">
        <v-form class="table-filters">
            <v-row dense>
                <v-col cols="12" md="4">
                    <daterange
                        :start-date-label="$t('pay_date_from')"
                        :end-date-label="$t('pay_date_to')"
                        :single-line="false"
                        :hide-details="true"
                        :min-start-date="null"
                        same-date
                        :_start-date="filters.paymentDateFrom"
                        :_end-date="filters.paymentDateTo"
                        :clearable="true"
                        @change-start-date="filters.paymentDateFrom = $event"
                        @change-end-date="filters.paymentDateTo = $event"
                    />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" md="4">
                    <v-text-field v-model="filters.referenceNumber" :label="$t('order_number')" hide-details />
                </v-col>
                <v-col cols="12" md="4">
                    <v-text-field v-model="filters.paymentNumber" :label="$t('transaction_number')" hide-details />
                </v-col>
            </v-row>
            <v-row dense class="mb-4">
                <v-col cols="12" md="4">
                    <v-text-field v-model="filters.paymentAccount" :label="$t('payment_account')" hide-details />
                </v-col>
                <v-col cols="12" md="4">
                    <v-autocomplete
                        v-model="filters.paymentProviderCode"
                        :items="onlinePaymentsProviders"
                        item-title="name"
                        item-value="code"
                        :label="$t('online_payment_provider')"
                        hide-details
                    />
                </v-col>
            </v-row>
        </v-form>
    </filters-wrapper>
</template>

<script setup lang="ts">
    import Daterange from '~/components/search/forms/Daterange.vue'

    const props = defineProps<{
        hasActiveFilters: boolean
        onlinePaymentsProviders: unknown[]
    }>()

    const filters = defineModel<unknown>()
    const emit = defineEmits<{
        (e: 'submit' | 'reset'): void
    }>()
</script>
